import React from 'react';
import clsx from 'clsx';
import startCase from 'lodash/startCase';

export type PCCStatusPillState =
  | 'enrolled'
  | 'eligible'
  | 'notEligible'
  | 'notEnrolled'
  | 'optedOut';

const BASE_CLASS = 'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold';

const PCC_STATUS_PILL_CLASS: Record<PCCStatusPillState, string> = {
  enrolled: 'bg-emerald-100 text-emerald-700',
  eligible: 'bg-blue-100 text-blue-700',
  notEligible: 'bg-gray-200 text-gray-700',
  notEnrolled: 'bg-gray-100 text-gray-600',
  optedOut: 'bg-gray-100 text-gray-600',
};

type Props = {
  state: PCCStatusPillState;
  className?: string;
};

export default function PCCStatusPill({
  state,
  className,
}: Props) {
  return (
    <span className={clsx(BASE_CLASS, PCC_STATUS_PILL_CLASS[state], className)}>
      {startCase(state)}
    </span>
  );
}
